import { createRouter, createWebHistory } from "vue-router";
import PerformanceList from "../components/PerformanceList.vue";
import PrivacyPolicy from "../views/PrivacyPolicy.vue";
import AdvertisingPolicy from "../views/AdvertisingPolicy.vue";

const routes = [
  { path: "/", component: PerformanceList },
  { path: "/privacy-policy", component: PrivacyPolicy },
  { path: "/advertising", component: AdvertisingPolicy },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
